module.exports = __webpack_public_path__ + "static/media/autMenores.189a5102.pdf";